import {
  UPDATE_EDUCATION_TYPE,
  UPDATE_OTHER_USE_CASE,
  UPDATE_USE_CASES,
  UPDATE_WELCOME,
  UPDATE_WELCOME_COMPANY,
  UPDATE_WELCOME_COMPANY_SIZE,
  UPDATE_WELCOME_COMPLETE,
  UPDATE_WELCOME_HELP_OPTIONS,
  UPDATE_WELCOME_INDUSTRY,
  UPDATE_WELCOME_MANAGEMENT_LEVEL,
  UPDATE_WELCOME_ROLE,
  UPDATE_WELCOME_STEP,
  UPDATE_WELCOME_USE_CASE_PLAN,
} from 'constants/actions';

const DEFAULT_WELCOME_STATE = {
  clearbit: {},
  clearbit_backfilled: false,
  clearbit_on_sign_up: false,
  complete: false, // has the user gotten through /welcome once at least
  company: null, // company of user that's onboarding
  company_size: null, // number of company employees, employeeRanges.js
  role: null, // role at company, employmentRoles.js -> ONBOARDING_JOB_ROLES
  custom_role: null, // if you choose "other" in role
  use_case_plan_persona: null, // same as use_case_plan but with a disctinction for teacher/student
  sharing_intent_case: null, // who are you sharing with
  other_intent_case_explanation: null, // if you choose other in sharing_intent_case
  management_level: null, // management level -> ONBOARDING_MANAGEMENT_LEVELS

  // LEGACY (we keep these to not break analytics as we update dashboards)
  use_case_plan: null, // what do you plan to use loom for?

  // DEPRECATED
  education_type: null, // teacher or student
  other_use_case: null, // other option for above
  step: 1, // step in 1 indexed
  helpOptions: {}, // how can loom help?
  use_cases: [], // What are you interested in using Loom for?
  company_industry: null, // industry company is in, industryTypes.js
};

const welcomeReducer = (state = DEFAULT_WELCOME_STATE, action) => {
  switch (action.type) {
    case UPDATE_EDUCATION_TYPE:
      return {
        ...state,
        education_type: action.educationType,
      };
    case UPDATE_OTHER_USE_CASE:
      return {
        ...state,
        other_use_case: action.otherUseCase,
      };
    case UPDATE_USE_CASES:
      return {
        ...state,
        use_cases: action.useCases,
      };
    case UPDATE_WELCOME:
      return {
        ...state,
        clearbit: action.welcomeState.clearbit,
        clearbit_backfilled: action.welcomeState.clearbitBackfilled,
        clearbit_on_sign_up: action.welcomeState.clearbitOnSignUp,
        company_industry: action.welcomeState.company_industry,
        company_size: action.welcomeState.company_size,
        company: action.welcomeState.company,
        complete: action.welcomeState.complete,
        education_type: action.welcomeState.education_type,
        other_use_case: action.welcomeState.other_use_case,
        role: action.welcomeState.role,
        custom_role: action.welcomeState.custom_role,
        management_level: action.welcomeState.management_level,
        use_case_plan: action.welcomeState.use_case_plan,
        use_cases: action.welcomeState.use_cases,
        use_case_plan_persona: action.welcomeState.use_case_plan_persona,
        sharing_intent_case: action.welcomeState.sharing_intent_case,
        other_intent_case_explanation:
          action.welcomeState.other_intent_case_explanation,
      };
    case UPDATE_WELCOME_COMPANY:
      return {
        ...state,
        company: action.company,
      };
    case UPDATE_WELCOME_COMPANY_SIZE:
      return {
        ...state,
        company_size: action.companySize,
      };
    case UPDATE_WELCOME_COMPLETE:
      return {
        ...state,
        complete: action.complete,
      };
    case UPDATE_WELCOME_INDUSTRY:
      return {
        ...state,
        company_industry: action.companyIndustry,
      };
    case UPDATE_WELCOME_ROLE:
      return {
        ...state,
        role: action.role,
        custom_role: action.custom_role,
      };
    case UPDATE_WELCOME_MANAGEMENT_LEVEL:
      return {
        ...state,
        management_level: action.management_level,
      };
    case UPDATE_WELCOME_USE_CASE_PLAN:
      return {
        ...state,
        use_case_plan: action.useCasePlan,
      };
    case UPDATE_WELCOME_STEP:
      return {
        ...state,
        step: action.step,
      };
    case UPDATE_WELCOME_HELP_OPTIONS:
      return {
        ...state,
        helpOptions: action.helpOptions || {},
      };
    default:
      return state;
  }
};

export default welcomeReducer;
